<button (click)="onToggled()" [class]="stateClassNames">
    <ng-container *ngIf="toggled">{{toggledText || text || ''}}</ng-container>
    <ng-container *ngIf="!toggled">{{notToggledText || text || ''}}</ng-container>
    <ng-content select="[aza-rws-toggle-button-content]"></ng-content>
    <ng-content *ngIf="toggled" select="[aza-rws-toggle-button-toggled-state-content]"></ng-content>
    <ng-content *ngIf="!toggled" select="[aza-rws-toggle-button-not-toggled-state-content]"></ng-content>
</button>
